module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "c-header"
  }, [_c('a', {
    staticClass: "c-header__logo",
    attrs: {
      "href": "https://www.airasia.com/en/home.page?utm_medium=display&utm_source=jnto&utm_campaign=d7_au_ptmkt%7Cjnto%7C04062018%7Cau-en",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'AirAsia Logo Top');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/airasia.svg"),
      "alt": "AirAsia"
    }
  })]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span', [_vm._v("The secret scrolls of")]), _vm._v("Ikigai")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-172f54b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainHeader.vue
// module id = 59
// module chunks = 0